import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artists: hasMany('artist', { inverse: null }),
  assetId: belongsTo('asset', { inverse: null }),
  assets: hasMany('asset', { inverse: null }),
  categoryId: belongsTo('category', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  documents: hasMany('asset', { inverse: null }),
  linkId: belongsTo('link', { inverse: null }),
  links: hasMany('link', { inverse: null }),
  mediaEmbed: belongsTo('media-embed', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  products: hasMany('product', { inverse: null }),
  recommendedArticles: hasMany('article', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  taxa: hasMany('taxon', { inverse: null }),
  variantChannel: belongsTo('channel', { inverse: null }),
});
